import React, { useEffect, useRef, useState } from 'react';


import { useTranslation } from 'react-i18next';
import { CarouselItemTemplate, CustomAddImage, CustomEditProfile, CustomFollowLayer, CustomGaleria, CustomInvite } from '../../components';
import AuthService from '../../security/AuthService';
import { Button } from 'primereact/button';
import { Link, useParams } from 'react-router-dom';
import ProfileService from '../../service/ProfileService';
import EventBus from "../../common/EventBus";
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';

import ReactPageScroller, { SectionContainer } from 'react-page-scroller';
import { SecondExhibitionPage } from './SecondExhibitionPage';
import { FirstExhibitionPage } from './FirstExhibitionPage';
import { SelectedExhibitionPage } from './SelectedExhibitionPage';
import ExhibitionService from '../../service/ExhibitionService';
import Constants from '../../constants/Constants';
import FavoriteService from '../../service/FavoriteService';
import utils from '../../constants/utils';


export const Exhibition = (props) => {
    console.log("Exhibition xxxxxxxxxxxxxxxxx",props)
    const { t } = useTranslation();
    const toast = useRef(null);

    const [displayLoadingDialog, setDisplayLoadingDialog] = useState(false);

    let { profileId, viewType } = useParams();


    const [currentPage, setCurrentPage] = useState(0);

    const [firstAdd, setFirstAdd] = useState(false);
    const [headerImageData, setHeaderImageData] = useState();
    const [addImageVisible, setAddImageVisible] = useState(false);
    const [imageFileType, setImageFileType] = useState();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [userName, setUserName] = useState("");

    const [userId, setUserId] = useState("");
    const [userType, setUserType] = useState("");


    const [exhibitionName, setExhibitionName] = useState("");
    const [exhibitionDescr, setExhibitionDescr] = useState("");
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(utils.plusDay(new Date(), 30));
    const [profileImage, setProfileImage] = useState();


    const [inviteVisible, setInviteVisible] = useState(false);
    const [artworks, setArtworks] = useState([]);
    const [selectedArtworks, setSelectedArtworks] = useState([]);
    const [selectedArtists, setSelectedArtists] = useState([]);

    const [isEditable, setIsEditable] = useState(viewType === 'edit');

    const [exhibitId, setExhibitId] = useState(profileId);
    const [isExhibitOwner, setIsExhibitOwner] = useState(false);

    const [isExistExhibit, setIsExistExhibit] = useState(false);
    const [favoriteId, setFavoriteId] = useState();

    const [status, setStatus] = useState();

    const [infoVisible, setInfoVisible] = useState(false);


    useEffect(() => {
        console.log("useEffect", isEditable)
        let _isEditable=isEditable;
        let _exhibitId=exhibitId;

        if(props.profileId){
            _exhibitId=props.profileId;
            setExhibitId(props.profileId);
            _isEditable=props.viewType === 'edit';
            setIsEditable(props.viewType === 'edit');
        }

        if (_isEditable) {
            loadUserArtworks();
          //  loadExhibit(_exhibitId);

        } else {
            loadExhibit(_exhibitId);
        }
    }, []);

    useEffect(() => {
    }, [selectedArtworks]);


    const handlePageChange = (param) => {
        console.log("handlePageChange", param, currentPage);
        setCurrentPage(param)
    }

    const handlePageNext = () => {
        setCurrentPage(currentPage + 1);
    }
    const handlePagePrevious = () => {
        setCurrentPage(currentPage - 1);
    }


    const loadUserArtworks = async () => {
        setDisplayLoadingDialog(true);
        setArtworks([]);
        ProfileService.inquireArtworks(AuthService.getUserId()).then(
            (response) => {

                console.log("loadUserArtworks", response)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set loadUserArtworks", response?.data?.data?.dataList)
                    setArtworks(response?.data?.data?.dataList);
                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                console.log("loadUserArtworks error*", error)

                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("loadUserArtworks logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );
    }
    const loadExhibit = async (_exhibitId) => {
        setDisplayLoadingDialog(true);
        setSelectedArtworks([]);

        ExhibitionService.inquireExhibit(_exhibitId).then(
            (response) => {

                console.log("inquireExhibit", response)
                if (response?.data?.data?.dataList?.length > 0) {
                    console.log("set inquireExhibit", response?.data?.data?.dataList)
                    let _exhibit = response?.data?.data?.dataList[0];
                    setIsExistExhibit(true);

                    setHeaderImageData(_exhibit.headerimageData);
                    setExhibitionName(_exhibit.exhibitionName);
                    setExhibitionDescr(_exhibit.exhibitionDescr);
                    setStartDate(_exhibit.startDate)
                    setEndDate(_exhibit.endDate);
                    setSelectedArtworks(_exhibit.selectedArtworks);
                    setFirstName(_exhibit.firstName);
                    setLastName(_exhibit.lastName);
                    setUserName(_exhibit.userName);
                    setProfileImage(_exhibit.profileImage);
                    setFavoriteId(_exhibit.favoriteId)
                    setStatus(_exhibit.status)
                    setIsExhibitOwner(_exhibit.userId==AuthService.getUserId());
                    setUserType(_exhibit.userType)
                    setUserId(_exhibit.userId)  

                    let _artists = [];

                    if (_exhibit.status === 1) {

                        setIsEditable(true);
                    } else {
                        setIsEditable(false);
                        setArtworks([]);
                    }

                    for (let index = 0; index < _exhibit.selectedArtworks.length; index++) {
                        const element = _exhibit.selectedArtworks[index];

                        _artists.push({ ownerName: element.ownerName, ownerId: element.ownerId, ownerUserName: element.ownerUserName, profileImage: element.profileImage });
                        console.log("selectedArtworks", element)
                    }

                    let unique_artists = _artists.filter((obj, index, self) =>
                        index === self.findIndex((t) => (
                            t.ownerId === obj.ownerId
                        ))
                    );


                    setSelectedArtists(unique_artists);

                }
                setDisplayLoadingDialog(false);
            },
            (error) => {
                console.log("inquireExhibit error*", error)

                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {

                    console.log("inquireExhibit logout******")
                    EventBus.dispatch("logout", props);
                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );
    }


    const addSelectedArtworks = (param) => {
        if (!isExistsSelectedArtworks(param)) {
            let maxCount = process.env.REACT_APP_MAX_EXHIBIT_ARTWORKS_COUNT;
            if (selectedArtworks.length >= maxCount) {
                toast.current.show({ severity: 'error', summary: t("global_error"), detail: t("global_error_exhibition_maxcount"), life: 5000 });

            } else {
                console.log("addSelectedArtworks", param)
                let _artworks = selectedArtworks;
                _artworks.push(param);
                setSelectedArtworks(_artworks);
                handlePageChange(_artworks.length);
                setFirstAdd(!firstAdd);
            }
        }
    }
    const removeSelectedArtworks = (param) => {
        let _artworks = selectedArtworks;
        _artworks = _artworks.filter((item) => item.file !== param.file);
        setSelectedArtworks(_artworks);
        //   handlePageChange(_artworks.length);
        setFirstAdd(!firstAdd);
    }

    const downSelectedArtworks = (param) => {

        const index = selectedArtworks.findIndex(item => item.file === param.file);
        if (index >= selectedArtworks.length - 1) return; // İlk elemanı yukarı taşıyamayız

        const newItems = [...selectedArtworks];
        // Elemanları yer değiştiriyoruz
        [newItems[index + 1], newItems[index]] = [newItems[index], newItems[index + 1]];

        setSelectedArtworks(newItems);


        handlePageChange(currentPage + 1);
        setFirstAdd(!firstAdd);
    }
    const upSelectedArtworks = (param) => {
        const index = selectedArtworks.findIndex(item => item.file === param.file);
        if (index <= 0) return; // İlk elemanı yukarı taşıyamayız

        const newItems = [...selectedArtworks];
        // Elemanları yer değiştiriyoruz
        [newItems[index - 1], newItems[index]] = [newItems[index], newItems[index - 1]];

        setSelectedArtworks(newItems);


        handlePageChange(currentPage - 1);
        setFirstAdd(!firstAdd);

    }


    const isExistsSelectedArtworks = (param) => {
        for (let i = 0; i < selectedArtworks.length; i++) {
            if (param.file === selectedArtworks[i]?.file) {
                console.log("isExistsSelectedArtworks", i + 1)
                handlePageChange(i + 1);
                return true;
            }

        }
        return false;

    }
    const onSelectArtPage = () => {
        setCurrentPage(0);

        console.log("onSelectArtPage", currentPage);

        setCurrentPage(1);
    }

    const onSaveExhibiton = (status) => {
        console.log("onSaveExhibiton Exhibition ", status, headerImageData, exhibitionName, exhibitionDescr, startDate, endDate, selectedArtworks);

        console.log("onSave");
        setDisplayLoadingDialog(true);

        let apiParams = {
            headerimageData: headerImageData, headerimageName: headerImageData?.fileName, exhibitionName: exhibitionName, exhibitionDescr: exhibitionDescr, startDate: startDate,
            endDate: endDate, selectedArtworks: selectedArtworks, status: status
        }

        console.log("onSave", apiParams);

        ExhibitionService.save(apiParams).then(
            (response) => {

                console.log("onSave", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }



                    toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    console.log("onSave xx" , response,profileId,response?.data?.data?.id);

                    setDisplayLoadingDialog(false);
                   
                    if (status==Constants.exhibitionStatus.IN_REVIEW ) {
                        setStatus(status);
                        setInfoVisible(true);
                    }
                    let _detail = t('global_success')
                    let _exhibitId=response?.data?.data?.id;
                    //http://localhost:3000/exhibition/view/1000012
                    props.navigate("/exhibition/view/" + _exhibitId );
                    loadExhibit(_exhibitId);
                    setIsEditable(false);
                    setExhibitId(_exhibitId);

                    toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }

    const onAddFavorite = (entityName, artwork) => {

        console.log("onAddFavorite");
        setDisplayLoadingDialog(true);

        let userId = AuthService.getUserId();

        let rowId = exhibitId;
        if (Constants.entityNames.artwork === entityName) {
            rowId = artwork?.id
        }

        let apiParams = { userId, entityName, rowId }

        console.log("onAddFavorite", apiParams);

        FavoriteService.add(apiParams).then(
            (response) => {

                console.log("onAddFavorite", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }


                    toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    console.log("onSave", response?.data?.data?.id);
                    if (Constants.entityNames.artwork === entityName) {
                        artwork.favoriteId = response?.data?.data?.id;
                    } else {
                        setFavoriteId(response?.data?.data?.id);
                    }

                    setDisplayLoadingDialog(false);

                    let _detail = t('global_success')

                    toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }


    const onRemoveFavorite = (favoriteId, artwork) => {

        console.log("onRemoveFavorite");
        setDisplayLoadingDialog(true);

        let userId = AuthService.getUserId();

        let rowId = exhibitId;

        let apiParams = { id: favoriteId }

        console.log("onRemoveFavorite", apiParams);

        FavoriteService.remove(apiParams).then(
            (response) => {

                console.log("onRemoveFavorite", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }


                    toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    if (artwork) {
                        artwork.favoriteId = null;
                    } else {
                        setFavoriteId();
                    }
                    console.log("onSave", response);

                    setDisplayLoadingDialog(false);

                    let _detail = t('global_success')

                    toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }


    const onUpdateExhibiton = (status) => {
        console.log("onSaveExhibiton Exhibition ", status, headerImageData, exhibitionName, exhibitionDescr, startDate, endDate, selectedArtworks);

        console.log("onSave");
        setDisplayLoadingDialog(true);

        let apiParams = {
            id: exhibitId, headerimageData: headerImageData, headerimageName: headerImageData?.fileName, exhibitionName: exhibitionName,
            exhibitionDescr: exhibitionDescr, startDate: startDate, endDate: endDate, selectedArtworks: selectedArtworks, status: status
        }

        console.log("onSave", apiParams);

        ExhibitionService.update(apiParams).then(
            (response) => {

                console.log("update", response);

                if (response?.data?.error) {
                    setDisplayLoadingDialog(false);

                    let _detail = response.data.error?.innerExceptionMessage;
                    if (t(_detail)) {
                        _detail = t(_detail);
                    }


                    toast.current.show({ severity: 'error', summary: t('global_text_errorsummary'), detail: _detail, life: 10000 });
                } else {
                    console.log("onSave", response);

                    setDisplayLoadingDialog(false);

                    if (Constants.exhibitionStatus.IN_REVIEW == status) {
                        setStatus(status);
                        setInfoVisible(true);
                    }
                    let _detail = t('global_success')

                    toast.current.show({ severity: 'success', summary: t('global_text_successsummary'), detail: _detail, life: 3000 });
                }
            },
            (error) => {
                setDisplayLoadingDialog(false);

                const _content =
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString();

                console.log(_content);

                if (error?.response?.status === 403 || error?.Error?.includes("403")) {
                    EventBus.dispatch("logout", props);

                } else {
                    toast.current.show({ severity: 'error', summary: t("global_error") + error?.response?.status, detail: t("global_error_detail"), life: 5000 });
                }
            }
        );


    }

    const onFileSelect = async (param) => {

        console.log("onFileSelect", param);
        let file = param.files[0];
        let _imageInfo;
        const reader = new FileReader();
        let blob = await fetch(file.objectURL).then(r => r.blob()); //blob:url
        reader.readAsDataURL(blob);
        reader.onloadend = function () {

            const base64data = reader.result;

            _imageInfo = { file: base64data, fileName: file.name, key: "images", code: Constants.fileTypes.exhibition_cover, upploadFlag: true, fileType: Constants.fileTypes.exhibition_cover };

            setHeaderImageData(_imageInfo);
            //   onClear();
            setAddImageVisible(false);
            console.log("onAddArtWork _imageInfo", _imageInfo)
        }
    };


    const uploadImageLayer = () => {
        return (
            <Dialog showCloseIcon closeOnEscape dismissable={false} visible={addImageVisible} position={'top'} onHide={() => setAddImageVisible(false)} className={'search-dialog'} headerClassName='search-dialog-header' contentClassName='search-dialog-content' >

                <CustomAddImage toast={toast} setDialogVisible={setAddImageVisible} {...props}
                    imageKey={"images"} code={Constants.fileTypes.exhibition_cover} fileType={Constants.fileTypes.exhibition_cover}
                    headerImageData={headerImageData}
                    setImage={setHeaderImageData}
                ></CustomAddImage>

            </Dialog>

        )


    }
    //const [currentPage, setCurrentPage] = useState(0);
    const [isScrolling, setIsScrolling] = useState(false);
  
    const handleBeforePageScroll = () => {
        setIsScrolling(true);
        setTimeout(() => setIsScrolling(false), 1000);
    };
    return (
        <div className='surface-profile-header'
        style={{ height: '100vh', 
            overflow: 'hidden',
            position: 'relative',
            width: '100%' }}
        >
            <Toast ref={toast} />
            <Dialog visible={displayLoadingDialog} breakpoints={{ '960px': '75vw' }} closable={false} className='p-dialog-load' header={<></>} >
                <div>
                    <img src="/assets/layout/images/page-loader.gif" alt='Loading...' width="125px" height="125px">
                    </img>
                </div>
            </Dialog>
            <ReactPageScroller
                pageOnChange={handlePageChange}
             //   onBeforePageScroll={handleBeforePageScroll}
                customPageNumber={currentPage}
                blockScrollUp={isScrolling}
                blockScrollDown={isScrolling}
                animationTimer={1000} // animasyon süresi (ms)
                transitionTimingFunction={"ease-out"} // animasyon tipi
                containerWidth={"100%"}
                containerHeight={"100vh"}
                renderAllPagesOnFirstRender={true}

            >
                <FirstExhibitionPage onSelectArtPage={onSelectArtPage}
                    exhibitionName={exhibitionName} setExhibitionName={setExhibitionName}
                    exhibitionDescr={exhibitionDescr} setExhibitionDescr={setExhibitionDescr}
                    startDate={startDate} setStartDate={setStartDate}
                    endDate={endDate} setEndDate={setEndDate}
                    isEditable={isEditable}
                    onSaveExhibiton={isExistExhibit ? onUpdateExhibiton : onSaveExhibiton}
                    setAddImageVisible={setAddImageVisible}
                    setImageFileType={setImageFileType}
                    headerImageData={headerImageData}
                    onFileSelect={onFileSelect}
                    isExistExhibit={isExistExhibit}
                    userName={userName}
                    firstName={firstName}
                    lastName={lastName}
                    selectedArtists={selectedArtists}
                    profileImage={profileImage}
                    onAddFavorite={onAddFavorite}
                    onRemoveFavorite={onRemoveFavorite}
                    favoriteId={favoriteId}
                    toast={toast}
                    status={status}
                    isExhibitOwner={isExhibitOwner}
                    userId={userId}
                    userType={userType}

                />

                {
                    selectedArtworks.map((param, index) => {

                        return (
                            <SelectedExhibitionPage key={index} index={index} handlePageChange={handlePageChange}
                                artwork={param} selectedIndex={index + 1} selectedCount={selectedArtworks.length}
                                removeSelectedArtworks={removeSelectedArtworks}
                                upSelectedArtworks={upSelectedArtworks} downSelectedArtworks={downSelectedArtworks}
                                onAddFavorite={onAddFavorite}
                                onRemoveFavorite={onRemoveFavorite}
                            />
                        )
                    })
                }

                <SecondExhibitionPage artworks={artworks} addSelectedArtworks={addSelectedArtworks}

                    exhibitionName={exhibitionName} setExhibitionName={setExhibitionName}
                    exhibitionDescr={exhibitionDescr} setExhibitionDescr={setExhibitionDescr}
                    startDate={startDate} setStartDate={setStartDate}
                    endDate={endDate} setEndDate={setEndDate}
                    viewType={viewType}
                    userName={userName}
                    firstName={firstName}
                    lastName={lastName}
                    isEditable={isEditable}
                    selectedArtists={selectedArtists}
                    profileImage={profileImage}
                    onAddFavorite={onAddFavorite}
                    onRemoveFavorite={onRemoveFavorite}
                    loadUserArtworks={loadUserArtworks}

                    favoriteId={favoriteId}


                />


            </ReactPageScroller>
            <Dialog header={t('global_text_info')} visible={infoVisible} style={{ width: '50vw' }} onHide={() => { if (!infoVisible) return; setInfoVisible(false); }}>
                <p className="m-0">
                   {t('global_exhibition_sendapprove')}
                </p>
            </Dialog>
        </div >
    );
};

